import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      isEmbedMode: 'embed/isEmbedMode',
      embedToken: 'embed/embedToken'
    })
  },
  methods: {
    // Navigate within iframe instead of opening new tabs
    navigateInIframe(path, params = {}) {
      if (this.isEmbedMode) {
        // Preserve embed mode and token in navigation
        const query = {
          ...params,
          embed: 'true',
          jwt: this.embedToken || this.$route.query.jwt
        };
        this.$router.push({ path, query });
      } else {
        // Normal navigation (can open in new tab)
        const routeData = this.$router.resolve({ path, query: params });
        window.open(routeData.href, '_blank');
      }
    },

    // Go back to scans page
    goBackToScans() {
      if (this.isEmbedMode) {
        this.$router.push({
          path: '/scans',
          query: {
            embed: 'true',
            jwt: this.embedToken || this.$route.query.jwt
          }
        });
      } else {
        this.$router.push('/scans');
      }
    },

    // Track which website is embedding this page
    trackEmbedUsage(pageName) {
      if (!this.isEmbedMode) return;

      try {
        const embedInfo = {
          page: pageName || this.$route.name || this.$route.path,
          referrer: document.referrer || null,
          timestamp: new Date().toISOString()
        };

        // Check for ancestorOrigins (Chrome/Edge only) - More reliable than referrer
        if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
          embedInfo.parentOrigin = window.location.ancestorOrigins[0];
        }

        // TODO: Optionally send to backend for analytics
        // this.$axios.post('/api/analytics/embed-usage', embedInfo);
      } catch (error) {
        // Silent fail
      }
    }
  }
}